import React, { useEffect, useRef, useState } from 'react';
import { Dimensions, Image as RNImage, Text, TouchableWithoutFeedback, View, } from 'react-native';
import { callInterceptor } from '../../utils/interceptor';
import { pick } from '../../utils/util';
import Icon from '../Icon';
import Popup from '../Popup';
import Swiper from '../Swiper';
import { useStyle } from './style';
const popupProps = ['visible'];
// export type ImagePreviewProps = ExtractPropTypes<typeof imagePreviewProps>;
const ImagePreview = (props) => {
    const { visible = false, autoPlay = false, loop = false, images = [], customStyle, closeable = true, showIndex = true, closeIcon = { name: 'kibt_common_base_close_28' }, closeIconPosition = 'top-right', startPosition = 0, index, onChange, onShow, beforeClose, onClose, customCover: CustomCover, customCloseIcon: CustomCloseIcon, } = props;
    const outerIndex = index !== null && index !== void 0 ? index : startPosition;
    const swiperRef = useRef(null);
    const { style: { closeIconStyle, indexStyle, indexFontStyle, imageItemStyle, imageWrapperStyle, }, } = useStyle({ closeIconPosition, customStyle });
    const [active, setActive] = useState(0);
    const emitClose = () => {
        callInterceptor(props.beforeClose, {
            args: [active],
            done: () => {
                props.onClose && props.onClose();
            },
        });
    };
    const [imageWrapperHeight, setImageWrapperHeight] = useState(0);
    const [imageTop, setImageTop] = useState(0);
    useEffect(() => {
        var _a;
        const { width, height } = Dimensions.get('window');
        if (typeof ((_a = props === null || props === void 0 ? void 0 : props.images) === null || _a === void 0 ? void 0 : _a[0]) === 'string') {
            RNImage.getSize(props.images[0], (imgWidth, imgHeight) => {
                const ratio = imgHeight / imgWidth;
                const imageHeight = Math.min(height, width * ratio);
                setImageWrapperHeight(imageHeight);
                const top = (height - imageHeight) / 2;
                setImageTop(top);
            }, () => { });
        }
    }, props.images);
    useEffect(() => {
        console.log('props.startPosition: ', props.startPosition);
        setActive(props.startPosition || 0);
    }, [props.startPosition]);
    const renderClose = () => {
        if (closeable) {
            return CustomCloseIcon ? (React.createElement(CustomCloseIcon, { active: active })) : (React.createElement(View, { style: closeIconStyle },
                React.createElement(Icon, Object.assign({}, closeIcon, { customStyle: {
                        iconSize: 26,
                    }, onPress: () => {
                        props.onClose();
                    } }))));
        }
    };
    const changeActive = (index) => {
        if (typeof onChange === 'function') {
            onChange(index);
        }
        setActive(index);
    };
    const onSwipeDown = () => {
        console.log('onSwipeDown: ', onSwipeDown);
    };
    const onClick = ({ locationX, locationY, pageX, pageY }) => {
        emitClose();
    };
    const [showImage, setShowImage] = useState(false);
    useEffect(() => {
        if (props.visible) {
            setShowImage(true);
        }
    }, [props.visible]);
    const renderImageItem = ({ item, index }) => {
        return React.isValidElement(item) ? (item) : (React.createElement("img", { style: { width: '100%' }, src: item }));
    };
    const renderImages = () => {
        return (React.createElement(Swiper, { ref: swiperRef, loop: true, autoPlay: false, initialIndex: startPosition, index: outerIndex, showIndicator: false, scalable: true, onIndexChanged: changeActive, customStyle: {
                borderRadius: 0,
                swiperHeight: Dimensions.get('window').height,
            }, data: props.images, renderItem: renderImageItem }));
    };
    const renderIndex = () => {
        if (showIndex) {
            return (React.createElement(View, { style: indexStyle },
                React.createElement(Text, { style: indexFontStyle }, `${props.images.length ? (active || 0) + 1 : 0} / ${props.images.length}`)));
        }
    };
    const renderCover = () => {
        return CustomCover ? React.createElement(CustomCover, { active: active }) : null;
    };
    return (React.createElement(Popup, Object.assign({ visible: visible, maskCloseable: true, lockScroll: true, position: "center", transition: "fade", duration: 200, onClose: () => {
            emitClose();
        }, maskOpacity: 0.8 }, pick(props, popupProps)), React.createElement(TouchableWithoutFeedback, { onPress: emitClose },
        React.createElement("div", null,
            renderClose(),
            renderImages(),
            renderIndex(),
            renderCover()))));
};
export { ImagePreview };
